export function galleryMarquee() {
    const marquee = document.querySelector('.gallery-slider__marquee');
    if (marquee) {
        const clone = marquee.innerHTML;
        marquee.innerHTML += clone;
    }
}